<template>
    <div class="products-buy-page">
        <div class="page-block ">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div class="info-form">
                    <div class="info-img">
                        <img :src="info.image || productsImage1"/>
                        <div>{{info.name||'劲步网关'}}</div>
                    </div>
                    <div class="form-content">
                        <div class="form-title">请您联系我们</div>
                        <div class="contact">
                            <div class="contact-item">
                                <div class="item-info">
                                    <div>
                                        <span>联系人</span>陈云
                                    </div>
                                    <div>
                                        <span>电话</span>15951960004
                                    </div>
                                    <div>
                                        <span>微信</span>15951960004
                                    </div>
                                    <div>
                                        <span>邮箱</span>chenyun@njysnet.com
                                    </div>
                                </div>
                                <div class="code-img">
                                    <img :src="code1"/>
                                </div>
                            </div>
                            <div class="contact-item">
                                <div class="item-info">
                                    <div>
                                        <span>联系人</span>王建勇

                                    </div>
                                    <div>
                                        <span>电话</span>13512516527
                                    </div>
                                    <div>
                                        <span>微信</span>13512516527
                                    </div>
                                    <div>
                                        <span>邮箱</span>2732229872@qq.com
                                    </div>
                                </div>
                                <div class="code-img">
                                    <img :src="code2"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
    </div>
</template>

<script>
    import Code1 from '../../image/common/code_img1.png'
    import Code2 from '../../image/common/code_img2.jpg'
    import ProductsImage1 from '../../image/common/products_image1.png'
    export default {
        name: "products-buy",
        data(){
            return{
                code2:Code2,
                code1:Code1,
                productsImage1:ProductsImage1,
                form:{
                    name:'',
                    companyName:'',
                    tel:'',
                    eMail:''
                },
                info:null
            }
        },
        created() {
            if(this.$route.query.value&&!this.$utils.isEmpty(this.$route.query.value)){
                this.info = this.$utils.decodeURIAndParse(this.$route.query.value);
            }
        }
    }
</script>

<style lang="scss" src="./products-buy.scss" scoped>

</style>
